import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { Box, IconButton, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteIcon from "@mui/icons-material/Delete";
import PropTypes from "prop-types";
import useMenuActions from "../../menu_utilities/menuOperation";
import DeleteItemPopover from "./deleteItemPopover";

function FoodCardActions({
  quantity,
  handleIncrement,
  handleDecrement,
  handleOpenItemDeleteDialog,
  fooditem,
  menuName,
  itemId,
}) {
  const { handleCloseDeleteItemDialog, handleDeleteItem } = useMenuActions();

  const { openItemDelete, deletePopoverId, anchorElId } = useSelector(
    (state) => state.menus
  );

  const anchorElRef = useRef(null);

  // const isDeletePopoverReady =
  //   openItemDelete &&
  //   deletePopoverId === fooditem.id &&
  //   anchorElId === `delete-icon-${fooditem.id}` &&
  //   !!anchorElRef.current;
  // console.log('FoodCardActions rendering:', fooditem.id);

  const itemName = `${fooditem.item_subcategory || ""} ${
    fooditem.item_type || ""
  } ${fooditem.item_name || ""}`.trim();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "0.3rem",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <IconButton
          id={`delete-icon-${fooditem.id}`}
          ref={anchorElRef}
          onClick={(event) =>
            handleOpenItemDeleteDialog(event, menuName, fooditem)
          }
          size="small"
          sx={{
            position: "absolute",
            top: 5,
            left: 0,
            zIndex: 1,
            backgroundColor: "white",
            borderRadius: "50%",
            padding: "4px",
            color: "red",
            "&:hover": {
              backgroundColor: "white",
            },
          }}
        >
          <DeleteIcon />
        </IconButton>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ml: 2,
          }}
        >
          <Typography
            className="responsive_fontsize12"
            sx={{ display: "inline" }}
            component="span"
            fontWeight="600"
            color="secondary.main"
          >
            Quantity: {quantity}
          </Typography>
          <IconButton
            type="button"
            size="small"
            onClick={() => handleDecrement(menuName, fooditem.id)}
          >
            <RemoveIcon />
          </IconButton>
          <IconButton
            type="button"
            size="small"
            onClick={() => handleIncrement(menuName, fooditem.id)}
          >
            <AddIcon />
          </IconButton>
        </Box>
      </Box>

      {openItemDelete &&
        deletePopoverId === fooditem.id &&
        anchorElId === `delete-icon-${fooditem.id}` && (
          <DeleteItemPopover
            open={true}
            handleCloseDeleteItemDialog={handleCloseDeleteItemDialog}
            fooditem={fooditem}
            anchorEl={anchorElRef.current}
            menuName={menuName}
            itemName={itemName}
            handleDeleteItem={handleDeleteItem}
          />
        )}
    </>
  );
}

FoodCardActions.propTypes = {
  quantity: PropTypes.number.isRequired,
  handleIncrement: PropTypes.func.isRequired,
  handleDecrement: PropTypes.func.isRequired,
  handleOpenItemDeleteDialog: PropTypes.func.isRequired,
  fooditem: PropTypes.object.isRequired,
  menuName: PropTypes.string.isRequired,
  itemId: PropTypes.number,
};

export default FoodCardActions;
